<template>
  <div>
    <v-container>
      <div>
        <v-layout>
          <v-flex xs12 sm6>
            <!-- <Multiselect
              @input="onFilterCampaign"
              :placeholder="$t('All')"
              v-model="filter.campaign"
              :options="campaignOption"
              :allow-empty="true"
              label="name"
            ></Multiselect> -->
          </v-flex>
          <v-flex xs12 sm6 class="text-xs-right">
            <v-btn @click="showAdvancedSearch" outline color="primary">Advanced Search </v-btn>
            <exportxlsx :promisedValue="getXlsxData" :filename="'coupon-report'"></exportxlsx>
          </v-flex>
        </v-layout>
      </div>
      <div class="mt-3">
        <v-pagination
          :total-visible="6"
          v-model="pageNumber"
          @input="changePage"
          :length="pagelength"
        ></v-pagination>
      </div>
      <div>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          hide-actions
          :pagination.sync="pagination"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <tr>
              <td>{{ props.item.name }}</td>
              <td>
                <template v-if="props.item.startdate">
                  {{ props.item.startdate | DateFormat('DD/MM/YYYY') }}
                </template>
                <template v-else>-</template>
              </td>
              <td>
                <template v-if="props.item.enddate">
                  {{ props.item.enddate | DateFormat('DD/MM/YYYY') }}
                </template>
                <template v-else>-</template>
              </td>
              <td>{{ props.item.code }}</td>
              <td>{{ props.item.quantity || '-' }}</td>
              <td>
                {{ props.item.total_codes_used !== null ? props.item.total_codes_used : '-' }}
              </td>
              <td>{{ props.item.remaining || '-' }}</td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-container>

    <!-- Search Dialog -->
    <v-dialog v-model="searchDialog" width="500px" persistent>
      <v-card>
        <div style="float: right">
          <v-btn @click="searchDialog = false" icon><v-icon>close</v-icon></v-btn>
        </div>
        <div class="pa-2 pt-4 pb-3">
          <div style="font-weight: 600; font-size: 20px"><v-icon>search</v-icon> ค้นหา</div>
          <div>
            <v-layout class="pa-0 ma-0" wrap row>
              <v-flex xs12 sm12 class="form-control pa-1">
                <label>{{ $t('Name') }}</label>
                <input v-model="filter.name" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm12 class="form-control pa-1">
                <label>{{ $t('Code') }}</label>
                <input v-model="filter.code" class="form-control" type="text" />
              </v-flex>
            </v-layout>
          </div>
          <div class="text-xs-center">
            <v-btn @click="clearsearch" outline color="grey">Clear</v-btn>
            <v-btn @click="onsearch" color="primary">Search</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import Multiselect from 'vue-multiselect'
import ReportCodeDialog from './ReportCodeDialog.vue'
import moment from 'moment'

export default {
  components: {
    exportxlsx,
    Multiselect,
    ReportCodeDialog
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 10)
      } else {
        return 1
      }
    }
  },
  data() {
    return {
      loading: false,
      items: [],
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      headers: [
        { text: 'Coupon Name', value: 'name', sortable: true },
        { text: 'Start Date', value: 'startdate', sortable: true },
        { text: 'End Date', value: 'enddate', sortable: true },
        { text: 'Code', value: 'code', sortable: false },
        { text: 'จำนวน Code ทั้งหมด', value: 'quantity', sortable: false },
        { text: 'จำนวน Code ที่ส่งไปแล้ว', value: 'total_codes_used', sortable: false },
        { text: 'จำนวน Code ที่เหลือ', value: 'remaining', sortable: false }
      ],
      searchDialog: false,
      filter: {
        name: '',
        code: '',
        campaign: ''
      },
      campaignOption: [],
      codeDialog: false,
      selectedCampaign: null
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    showAdvancedSearch() {
      this.searchDialog = true
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getData()
      }
    },
    onsearch() {
      this.searchDialog = false
      this.getData()
    },
    clearsearch() {
      this.searchDialog = false
      this.filter = {
        name: '',
        code: ''
      }
      this.getData()
    },
    async getCampaigns() {
      let request = {
        pageid: this.selectedBot.pageid
      }
      let response = await api.getFollowMessageCampaigns(request)

      if (response.status == true) {
        this.campaignOption = response.result
      } else return []
    },
    async getData() {
      return new Promise(async (resolve) => {
        let request = {
          pageid: this.selectedBot.pageid,
          limit: this.limit,
          offset: this.offset
        }

        if (this.filter.name) {
          Object.assign(request, { name: this.filter.name })
        }
        if (this.filter.code) {
          Object.assign(request, { code: this.filter.code })
        }

        this.loading = true

        let response = await api.cityfreshGetPromotionCode(request)
        this.loading = false

        if (response.data) {
          const data = response.data
          const items = data.map((el) => {
            let totalCodeUsed = null
            if (el.quantity && el.remaining) {
              totalCodeUsed = parseInt(el.quantity) - parseInt(el.remaining)
            }

            return {
              ...el,
              total_codes_used: totalCodeUsed
            }
          })

          this.items = items
          this.total = response.total

          resolve(items)
        } else return []
      })
    },
    getXlsxData() {
      return new Promise(async (resolve) => {
        this.limit = this.total
        var data = await this.getData()

        resolve(
          data.map((el) => {
            return {
              'Campaign Name': el.name,
              'Start Date': el.start_date ? moment(el.startdate).format('DD/MM/YYYY') : '-',
              'End Date': el.enddate ? moment(el.enddate).format('DD/MM/YYYY') : '-',
              Code: el.code,
              'จำนวน Code ทั้งหมด': el.quantity ? el.quantity : '-',
              'จำนวน Code ที่ส่งไปแล้ว': el.total_codes_used !== null ? el.total_codes_used : '-',
              'จำนวน Code ที่เหลือ': el.remaining ? el.remaining : '-'
            }
          })
        )

        this.limit = 10
        this.getData()
      })
    },
    onFilterCampaign(campaign) {
      if (campaign) {
        this.filter.campaign = campaign
      } else {
        this.filter.campaign = ''
      }

      this.getData()
    },
    onViewCode(campaign) {
      this.selectedCampaign = campaign
      this.codeDialog = true
    },
    closeCodeDialog() {
      this.selectedCampaign = null
      this.codeDialog = false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/CouponReport.vue